import { Subject } from "rxjs";

export default {
  namespaced: false,
  state: {
    listeners: []
  },
  getters: {
    listeners: state => state.listeners
  },
  mutations: {
    register_listener(state, subject) {
      state.listeners.push(subject);
    },
    remove_listener(state, listener) {
      const idx = state.listeners.findIndex(l => l === listener);
      if (idx >= 0)
        state.listeners.splice(idx, 1);
      else
        console.error("Tried to remove a listener that was not registered.");
    },
  },
  actions: {
    attatch_listener({ commit }, payload) {
      const subject = new Subject();
      const detatch = setupOnSnapshotListener(payload.ref, subject);
      commit("register_listener", subject);
      subject.subscribe({
        next: setupOnNextListener(payload.mutation, commit),
        complete: () => {
          commit("remove_listener", subject);
          detatch();
        }
      });
      return subject;
    },
    detatch_all_listeners({ getters }) {
      getters.listeners.forEach(listener => {
        listener.complete();
      });
    }
  }
};

function setupOnNextListener(mutation, commit) {
  if (typeof mutation === "string")
    return snapshot => commit(mutation, snapshot, { root: true });

  if (typeof mutation === "function")
    return snapshot => mutation(snapshot);

  return () => {};
}

function setupOnSnapshotListener(ref, subject) {
  return ref.onSnapshot(snapshot => {
    subject.next(snapshot);
  });
}